import {
  PasswordField as DSPasswordField,
  type PasswordFieldProps,
} from '@hostfully/ui-components';
import { useTranslation } from 'react-i18next';

const PasswordField = (props: PasswordFieldProps) => {
  const { t } = useTranslation();
  return (
    <DSPasswordField
      {...props}
      showPasswordLabel={t('form.passwordField.show')}
      hidePasswordLabel={t('form.passwordField.hide')}
      strengthLabels={{
        weak: t('form.passwordField.strength.weak'),
        medium: t('form.passwordField.strength.medium'),
        strong: t('form.passwordField.strength.strong'),
      }}
    />
  );
};

export type { PasswordFieldProps };
export default PasswordField;
